





































































import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import FramePuzzleCollageEditor from "@/components/products/framepuzzle/FramePuzzleCollageEditor.vue"
import FramePuzzleCollageEditorError from "@/components/products/framepuzzle/FramePuzzleCollageEditorError.vue"
import { AssetFile, SingleAssetUsage } from '@/store/modules/asset'
import { AssetsModule } from '@/store/modules/asset'
import { AppModule } from '@/store/modules/app'
import { FramePuzzleModule, PuzzleFormat } from '../../../../store/modules/framePuzzle'

@Component({
    name: 'frame-puzzle',
    components: {
        FramePuzzleCollageEditor,
        FramePuzzleCollageEditorError
    }
})
export default class FramePuzzle extends Vue {
    private containerWidth = window.innerWidth > 1145 ? 460 : (window.innerWidth > 534 ? 430 : 257)
    private containerHeight = window.innerWidth > 534 ? 457 : 435
    private image = { url: '', style: '' }
    private oldImage = { url: '', style: '' }
    private placeholderBlending = false

    get selectedAssets() {
        return AssetsModule.selectedAssets
    }

    get showPreview() {
        if (FramePuzzleModule.showImagePreview) {
            if (this.image.url === "" && this.oldImage.url === "") {
                return false
            } else {
                return true
            }
        }
        return FramePuzzleModule.userFormat === "" && (this.image.url !== "" || this.oldImage.url !== "")
    }

    get disabledMovement() {
        return ToolbarModule.deactivated & ToolbarDeactivations.ZoomAndRotation
    }

    get imageEditorWidth() {
        return FramePuzzleModule.imageEditorWidth
    }

    get imageEditorHeight() {
        return FramePuzzleModule.imageEditorHeight
    }

    get disabledToolbar() {
        if (FramePuzzleModule.showToolbar) {
            return AssetsModule.selectedAssets.length === 0 || FramePuzzleModule.userFormat === ""
        }
        return true
    }

    get showMenu() {
        return AppModule.showMenu
    }

    get recoverPuzzleToogled() {
        return FramePuzzleModule.recoverPuzzleToggled
    }

    getContainerWidth() {
        this.containerWidth = window.innerWidth > 1145 ? 460 : (window.innerWidth > 534 ? 430 : 257)
    }

    getContainerHeight() {
        this.containerHeight = window.innerWidth > 534 ? 457 : 435
    }

    @Watch('selectedAssets')
    selectedAssetsChanged(newSelectedAssets: AssetFile[]) {
        if (FramePuzzleModule.showImagePreview) {
            let asset: AssetFile | undefined = AssetsModule.selected
            if (this.image.url !== '') {
                this.oldImage = { url: this.image.url, style: this.image.style }
            } else {
                this.oldImage = { url: '', style: '' }
            }
            if (asset !== undefined) {
                let width = asset.rect[0]
                let height = asset.rect[1]
                let scale = 1
                let translateX = 0
                let translateY = 0
                if (width >= height) {
                    scale = 400 / width
                    translateX = Math.round(((500 - (width * scale)) / 2) * (1 / scale))
                    translateY = Math.round(((400 - (height * scale)) / 2) * (1 / scale))
                } else {
                    scale = 400 / height
                    translateX = Math.round(((500 - (width * scale)) / 2) * (1 / scale))
                }
                setTimeout(() => {
                    this.image.url = asset!.url
                    this.image.style = 'transform: scale('
                        + scale + ') translateX('
                        + translateX + 'px) translateY('
                        + translateY + 'px);'
                    setTimeout(() => {
                        this.placeholderBlending = true
                        setTimeout(() => {
                            this.oldImage = { url: '', style: '' }
                            this.placeholderBlending = false
                        }, 500)
                    }, 100)
                }, 100)
            }
        } else if (Object.keys(FramePuzzleModule.persistedAssets).length === 0) {
            this.image = { url: '', style: '' }
            this.oldImage = { url: '', style: '' }
        }
    }

    //prevent img change on reentering step after img change and cancel
    @Watch('showPreview')
    showPreviewChanged(newShowPreview: boolean) {
        if (!newShowPreview) {
            let persistedAsset = FramePuzzleModule.persistedAssets["frameimage"]
            if (persistedAsset !== undefined && this.selectedAssets[0].url !== persistedAsset.url) {
                let width = persistedAsset.rect[0]
                let height = persistedAsset.rect[1]
                let scale = 1
                let translateX = 0
                let translateY = 0
                if (width >= height) {
                    scale = 400 / width
                    translateX = Math.round((500 - (width * scale)) / 2) * (1 / scale)
                    translateY = Math.round((400 - (height * scale)) / 2) * (1 / scale)
                } else {
                    scale = 400 / height
                    translateX = Math.round((500 - (width * scale)) / 2) * (1 / scale)
                }
                this.image.url = persistedAsset.url
                this.image.style = 'transform: scale('
                    + scale + ') translateX('
                    + translateX + 'px) translateY('
                    + translateY + 'px);'
            } else {
                this.image = { url: '', style: '' }
                this.oldImage = { url: '', style: '' }
            }
        }
    }

    //prevent false img on cancel when step 2 uncompleted
    @Watch('recoverPuzzleToogled')
    recoverPuzzleToogledChanged(newRecoverPuzzleToogled: boolean) {
        if (FramePuzzleModule.userFormat === '') {
            let persistedAsset = FramePuzzleModule.persistedAssets["frameimage"]
            if (persistedAsset !== undefined) {
                let width = persistedAsset.rect[0]
                let height = persistedAsset.rect[1]
                let scale = 1
                let translateX = 0
                let translateY = 0
                if (width >= height) {
                    scale = 400 / width
                    translateX = Math.round((500 - (width * scale)) / 2) * (1 / scale)
                    translateY = Math.round((400 - (height * scale)) / 2) * (1 / scale)
                } else {
                    scale = 400 / height
                    translateX = Math.round((500 - (width * scale)) / 2) * (1 / scale)
                }
                this.image.url = persistedAsset.url
                this.image.style = 'transform: scale('
                    + scale + ') translateX('
                    + translateX + 'px) translateY('
                    + translateY + 'px);'
            }
        }
    }

    mounted() {
        this.$nextTick(function () {
            window.addEventListener("resize", this.getContainerWidth)
            window.addEventListener("resize", this.getContainerHeight)
            this.getContainerWidth()
            this.getContainerHeight()
        })
        this.selectedAssetsChanged(AssetsModule.selectedAssets)
    }

    beforeDestroy() {
        window.removeEventListener("resize", this.getContainerWidth)
        window.removeEventListener("resize", this.getContainerHeight)
    }

}
